module.exports = __webpack_public_path__ + "assets/img/elem5-ability1.4b9740bb.gif";